import clsx from 'clsx';

/**
 * Animated status orb for the voice session.
 * states: idle | connecting | live | limited | error (+ speaking / userSpeaking accents)
 */
export function VoiceOrb({ status, speaking, userSpeaking }) {
  const label =
    status === 'connecting' ? 'Connessione...'
      : status === 'limited' ? 'Limite raggiunto'
        : status === 'error' ? 'Errore'
          : status !== 'live' ? 'Inattivo'
            : speaking ? 'Assistente parla'
              : userSpeaking ? 'Ti ascolto'
                : 'In ascolto';

  const tone = status === 'error'
    ? 'bg-danger/15 text-danger ring-danger/30'
    : status === 'limited'
      ? 'bg-warning/15 text-warning ring-warning/30'
      : speaking
        ? 'bg-accent-soft text-accent ring-accent/40'
        : userSpeaking
          ? 'bg-success/15 text-success ring-success/40'
          : status === 'live'
            ? 'bg-surface-subtle text-ink ring-border-strong'
            : 'bg-surface-subtle text-ink-muted ring-border';

  return (
    <div className="flex flex-col items-center gap-3">
      <div className={clsx('relative flex h-32 w-32 items-center justify-center rounded-full ring-2 transition-colors', tone)}>
        <span className={clsx(
          'absolute inset-0 rounded-full',
          (speaking || userSpeaking) && 'animate-ping opacity-40',
          speaking ? 'bg-accent/30' : userSpeaking ? 'bg-success/30' : 'bg-transparent'
        )} />
        <span className={clsx(
          'h-16 w-16 rounded-full transition-transform',
          status === 'connecting' && 'animate-pulse',
          speaking ? 'scale-110 bg-accent/60' : userSpeaking ? 'scale-105 bg-success/60' : 'bg-ink/15'
        )} />
      </div>
      <span className="text-sm font-medium text-ink-muted">{label}</span>
    </div>
  );
}
